import script from "./TaxBreakdownChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaxBreakdownChart.vue?vue&type=script&setup=true&lang=ts"

import "./TaxBreakdownChart.vue?vue&type=style&index=0&id=7b8591d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b8591d3"]])

export default __exports__